module.exports = __webpack_public_path__ + "static/media/bolso (3).28ab4f1a.jpg";